import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UploadFloorPlanForm } from '@/features/estate-media/components/upload-floor-plan-form';

import { Modal } from './new/modal';
import type { useModal } from './new/use-modal';

type UploadFloorPlanModalProps = {
  modal: ReturnType<typeof useModal>;
};

export const UploadFloorPlanModal: FC<UploadFloorPlanModalProps> = ({ modal }) => {
  const { t } = useTranslation();
  const [isUploading, setIsUploading] = useState(false);

  return (
    <Modal
      {...modal}
      dismissDisabled={isUploading}
      title={t('uploadFloorPlan')}
      type="custom"
      className="w-[calc(100dvw-1.5rem)] max-w-screen-sm bg-white p-0 sm:w-[40rem] sm:max-w-[66dvw]"
    >
      <UploadFloorPlanForm
        closeModal={modal.dismiss}
        label={t('uploadFloorPlan')}
        onUploadingChange={setIsUploading}
      />
    </Modal>
  );
};
